import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'redispatch-confirm-dialog',
    template: `
        <div data-qa="confirm-dialog">
          @if (data.title) {
            <h1 mat-dialog-title
              data-qa="confirm-dialog-title">
              {{data.title}}
            </h1>
          }

          <mat-dialog-content [innerHTML]="data.message"
            data-qa="confirm-dialog-content">
          </mat-dialog-content>

          <mat-dialog-actions style="justify-content: flex-end;">
            @if (data.cancelMessage) {
              <button matButton="outlined"
                data-qa="confirm-dialog-cancel-button"
                [mat-dialog-close]="false"
                >
                  <mat-icon [svgIcon]="data.cancelIcon || 'innogy_picto_close'"></mat-icon>
                  {{ data.cancelMessage }}
              </button>
            }
            <button matButton="filled"
                    cdkFocusInitial
              data-qa="confirm-dialog-submit-button"
              [mat-dialog-close]="true"
                    class="button-{{ data.confirmColor }}">
                <mat-icon svgIcon="innogy_picto_check"></mat-icon>
              {{ data.confirmMessage }}
            </button>
          </mat-dialog-actions>
        </div>
        `,
    styles: [
        `
            h1 {
                font-family: 'innogy-regular', Roboto, "Helvetica Neue", sans-serif !important;
                font-weight: bold !important;
            }
        `,
    ],
    standalone: false,
})
export class ConfirmDialogComponent {
    public data = inject<{
        message: string,
        title?: string,
        cancelMessage: string,
        cancelIcon?: string,
        confirmMessage: string,
        confirmColor: 'primary' | 'warn' | 'accent'
    }>(MAT_DIALOG_DATA);
}
